import EntityModel from '@/common/models/entity-model';
import {actionToMethodPermissions, isAdmin, methodToActionPermissions} from '@/common/auth/auth-helper';
import RESOURCES from '@/common/auth/definitions/resources';
import dataToHash from '@/common/helpers/data2hash';
import truncate from '@/common/helpers/truncate';

export default class UserModel extends EntityModel {
    get fullName() {
        return `${this.firstName || ''} ${this.lastName || ''}`.trim() || `(${truncate(this.id)})`;
    }

    hydrate({
        id = null,
        email = null,
        firstName = null,
        lastName = null,
        businessPhone = null,
        mobilePhone = null,
        password = null,
        permissions = null,
        createdTime = null,
        updatedTime = null,
        loginTime = null,
        reportingCurrency = null,
        availableCurrencies = null,
        totpRequired = null,
        totpSecret = null,
        totpUrl = null,
        status = null,
        country = null,
        preferences = {},
    } = {}) {
        this.id = id;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
        this.businessPhone = businessPhone;
        this.mobilePhone = mobilePhone;
        this.password = password;
        this.permissions = isAdmin(permissions) ? null : methodToActionPermissions(permissions);
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        this.loginTime = loginTime;
        this.reportingCurrency = reportingCurrency;
        this.availableCurrencies = availableCurrencies;
        this.totpRequired = totpRequired;
        this.totpSecret = totpSecret;
        this.totpUrl = totpUrl;
        this.status = status;
        this.country = country;
        this.preferences = preferences || {};
    }

    getPayload() {
        const permissions = actionToMethodPermissions(this.permissions, RESOURCES);

        return {
            id: this.id,
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            preferences: {
                ...this.preferences,
                hashes: {
                    permissions: dataToHash(permissions),
                },
            },
            permissions,
        };
    }
}
